"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOOKING_DASHBOARD_ROLES = exports.BOOKING_WRITE_ROLES = exports.BOOKING_READ_ROLES = void 0;
const Roles_1 = require("../enums/Roles");
exports.BOOKING_READ_ROLES = [Roles_1.Roles.CallmartOSP, Roles_1.Roles.CallmartWFM, Roles_1.Roles.CallmartWTM];
exports.BOOKING_WRITE_ROLES = [Roles_1.Roles.CallmartOSP];
// Frontend-only: manager + stakeholder dashboards in Buchung sidebar (Calldeltas, dailyOSPBookings).
// Backend booking routes accept the full BOOKING_READ_ROLES set.
exports.BOOKING_DASHBOARD_ROLES = [Roles_1.Roles.CallmartWFM, Roles_1.Roles.CallmartWTM];
